import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';

export const { updateNotificationCount, updateCommentHint } = createActions({
  updateNotificationCount: result => result,
  updateCommentHint: result => result
});

const initState = Map({
  count: 0,
  /** 评论红点 */
  commentHint: false
});

const notification = handleActions(
  {
    [updateNotificationCount]: (state, action) => {
      let newCount = action.payload.count;
      if (typeof newCount === 'function') {
        return state.set('count', newCount(state.get('count')));
      }
      return state.set('count', newCount);
    },
    [updateCommentHint]: (state, action) => {
      return state.set('commentHint', action.payload);
    }
  },
  initState
);

export default notification;
